module.exports = __webpack_public_path__ + "js/0.7cb0b1b8.worker.js"